import z from 'zod';
import { optionSchemaRequired } from '~/features/types';

export const CompensationFormSchema = z
  .object({
    id: z.number().optional(),
    jobListingId: z.number().optional(),
    laborReqType: z.string().optional().nullable(),
    compType: optionSchemaRequired,
    pricePerHour: z.preprocess(
      (arg) => (arg === null || arg === '' ? null : Number(arg)),
      z.number().optional().nullable()
    ),
    pricePerShift: z.preprocess(
      (arg) => (arg === null || arg === '' ? null : Number(arg)),
      z.number().optional().nullable()
    ),
    pricePerRvu: z.preprocess(
      (arg) => (arg === null || arg === '' ? null : Number(arg)),
      z.number().optional().nullable()
    ),
    rvusPerPeriod: z.preprocess(
      (arg) => (arg === null || arg === '' ? null : Number(arg)),
      z.number().optional().nullable()
    ),
    rvuPeriod: optionSchemaRequired.optional().nullable(),
  })
  .refine(
    (schema) => {
      if (schema.compType.value === 'HOUR') {
        return schema.pricePerHour !== undefined && schema.pricePerHour !== null;
      }
      return true;
    },
    {
      message: 'Required',
      path: ['pricePerHour'],
    }
  )
  .refine(
    (schema) => {
      if (schema.compType.value === 'SHIFT') {
        return schema.pricePerShift !== undefined && schema.pricePerShift !== null;
      }
      return true;
    },
    {
      message: 'Required',
      path: ['pricePerShift'],
    }
  )
  .refine(
    (schema) => {
      if (schema.compType.value === 'RVU') {
        return schema.pricePerRvu !== undefined && schema.pricePerRvu !== null;
      }
      return true;
    },
    {
      message: 'Required',
      path: ['pricePerRvu'],
    }
  )
  .refine(
    (schema) => {
      if (schema.compType.value === 'RVU' && schema.laborReqType === 'FTE') {
        return schema.rvusPerPeriod !== undefined && schema.rvusPerPeriod !== null;
      }
      return true;
    },
    {
      message: 'Required',
      path: ['rvusPerPeriod'],
    }
  )
  .refine(
    (schema) => {
      if (schema.compType.value === 'RVU' && schema.laborReqType === 'FTE') {
        return Boolean(schema.rvuPeriod?.value);
      }
      return true;
    },
    {
      message: 'Required',
      path: ['rvuPeriod'],
    }
  );
export type CompensationFormValues = z.infer<typeof CompensationFormSchema>;
